import * as React from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import PhotoIcon from '@mui/icons-material/CameraAltOutlined';
import IdIcon from '@mui/icons-material/BadgeOutlined';
import BeachAccessIcon from '@mui/icons-material/BeachAccess';
import { t } from '~/utils/narration';

export default function KycSteps() {
  return (
    <List sx={{ width: '100%', bgcolor: 'transparent' }}>
      <ListItem sx={{ pl: 0 }}>
        <ListItemAvatar>
          <Avatar sx={{ background: "transparent"}}>
            <PhotoIcon sx={{ fill: "#8A8AA3", width: '1.0em', height: '1.0em' }} />
          </Avatar>
        </ListItemAvatar>
        <ListItemText
          primary={t({ en: 'Take a selfie', hi: 'एक सेल्फ़ी लें' })}
          secondary={t({ en: 'To know that you are really present', hi: 'यह जानने के लिए कि आप वास्तव में मौजूद हैं' })}
        />
      </ListItem>
      <ListItem sx={{ pl: 0 }}>
        <ListItemAvatar>
          <Avatar sx={{ background: "transparent"}}>
            <IdIcon sx={{ fill: "#8A8AA3", width: '1.0em', height: '1.0em' }} />
          </Avatar>
        </ListItemAvatar>
        <ListItemText
          primary={t({ en: 'Take a picture of your ID document', hi: 'अपने पहचान डॉक्यूमेंट की तस्वीर लें' })}
          secondary={t({ en: 'To verify your personal information from it', hi: 'इससे आपकी व्यक्तिगत जानकारी वेरिफ़ाई करने के लिए' })}
        />
      </ListItem>
    </List>
  );
}
